import ReactDOM from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import store, { persistor } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
import Routing from "./routing/Routing";
import ErrorBoundary from "./components/common/error/Error.Boundry.component";
import { GoogleReCaptchaProvider } from "@google-recaptcha/react";
import { getGoogleCaptchaAPIKey } from "./service/common";
import { IntercomProvider } from "react-use-intercom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import "./index.scss";
import IntercomManager from "./custom_hooks/IntercomManager";
import { injectStore } from "./service/api.service";

injectStore(store);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const intercomID = process.env.REACT_APP_INTERCOM || "mse6jhbe";

root.render(
  <IntercomProvider appId={intercomID} autoBoot={false}>
    <GoogleReCaptchaProvider type="v3" siteKey={getGoogleCaptchaAPIKey()}>
      <ErrorBoundary>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <IntercomManager />
            <App />
            <Routing />
          </PersistGate>
        </Provider>
      </ErrorBoundary>
    </GoogleReCaptchaProvider>
  </IntercomProvider>
);
